import { noop } from 'lodash';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { Menu, Tooltip } from '@mantine/core';
import { IconSignature } from '@tabler/icons-react';
import useSignAction from 'components/tables/data/revision/actions/hooks/use-sign-action';
import { useSignRevisionModal } from 'components/modals/sign-revision-modal/SignRevisionModalProvider';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the user who is the technician of the revision.
 */
export default function SignAction({ revision, onStatusChange = noop, kind }: RevisionSingleActionProps) {
  const { signRevision } = useSignAction();
  const { signRevisionModal } = useSignRevisionModal();

  /**
   * Confirms the redirect to the third party to sign the revision.
   */
  const confirmSignRevision = () =>
    signRevisionModal({
      revisionIds: [revision.revisionId],
      message:
        revision.kind === 'revision'
          ? 'Revízna správa bude odoslaná do systému BrainIT. Pre jej podpísanie budete presmerovaný do ich webového portálu.'
          : 'Formulár bude odoslaný do systému BrainIT. Pre jeho podpísanie budete presmerovaný do ich webového portálu.',
      onSign: ({ deadline }) => signRevision({ revision, deadline, onStatusChange }),
    });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Podpísať" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" onClick={confirmSignRevision}>
          <IconSignature stroke={1.5} size={24} />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button
        size="md"
        onClick={confirmSignRevision}
        leftIcon={<IconSignature stroke={1.5} size={24} />}
        variant="secondary"
        w={188}
      >
        Podpísať
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" onClick={confirmSignRevision} icon={<IconSignature stroke={1.5} size={24} />}>
      Podpísať
    </Menu.Item>
  );
}
